import { supabase } from '@/integrations/supabase/client';

export interface GoogleSearchResult {
  success: boolean;
  brandName: string;
  targetKeyword?: string;
  platform: string;
  found: boolean;
  position: number | null;
  context: string;
  confidence: 'high' | 'medium' | 'low';
  topCompetitors?: string[];
  domainVerified?: boolean;
  spellingCorrected?: boolean;
  suggestedQuery?: string;
  error?: string;
}

export async function scanGoogleSearchVisibility(
  brandName: string,
  targetKeyword?: string,
  websiteUrl?: string
): Promise<GoogleSearchResult> {
  const { data, error } = await supabase.functions.invoke('google-search-visibility', {
    body: { brandName, targetKeyword, websiteUrl },
  });

  if (error) {
    throw new Error(error.message || 'Failed to scan Google Search visibility');
  }

  if (data.error) {
    throw new Error(data.error);
  }

  return data as GoogleSearchResult;
}
